import { FormControlLabel, Radio } from '@mui/material'
import styled from '@emotion/styled'

export const OptionsBaseContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const OptionsRow = styled.div`
  display: flex;
  gap: 24px;
`

export const RadioFormControlLabel = styled(FormControlLabel)`
  display: flex;
  margin: 0;
  white-space: nowrap;
  width: 90px;
`

export const RadioButton = styled(Radio)`
  padding: 0 8px 0 0;
`
